module.exports = __webpack_public_path__ + "img/acccc.ae5ba31b.jpg";